module.exports = __webpack_public_path__ + "static/media/lympne-3.eb234a29.jpg";